var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2585 6.07013L9.42449 3.00627C8.57884 2.33334 7.39801 2.33395 6.55052 3.0075L2.74294 6.06274C2.2786 6.41582 2.00738 6.95158 2 7.5378V13.4281C2 14.0198 2.48094 14.5008 3.07259 14.5008H5.19501H10.8175H12.9202C13.5119 14.5008 13.9928 14.0198 13.9928 13.4281V7.53042C13.983 6.95096 13.7038 6.40167 13.2585 6.07013Z",
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26562 13.4296C6.26562 14.0213 6.26562 14.5023 6.26562 14.5023H9.74291C9.74291 14.5023 9.74291 14.0213 9.74291 13.4296V11.273C9.74291 10.7901 9.55041 10.3411 9.20046 10.0089C8.85113 9.67802 8.38803 9.50948 7.90893 9.5347C7.00301 9.58268 6.26562 10.4174 6.26562 11.3954V13.4296Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGray);
export default __webpack_public_path__ + "static/media/home_gray.d7361b9d2dda7bb5ba3f6bb20f5cba07.svg";
export { ForwardRef as ReactComponent };